var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"location",staticClass:"location md-primary md-body-1"},[_c('span',{staticClass:"location-text"},[_vm._v(" "+_vm._s('Latitude: ' + _vm.lat)+" "),_c('br'),_vm._v(" "+_vm._s(' Longitude: ' + _vm.lng)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }